import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Warning from "@material-ui/icons/Warning"

interface IErrorHint {
    errMsg: string
}

const useStyles = makeStyles({
    wrapper: {
        backgroundColor: "#F7F1F1",
        border: "1px solid #FB8383",
        borderRadius: "3px",
        color: "#F85646",
        display: "flex",
        fontSize: "16px",
        minWidth: "200px",
        minHeight: "56px",
        justifyContent: "center",
        "& > div": {
            padding: "10px 10px",
            display: "flex",
            alignItems: "center",
            "&:first-child": {
                flexShrink: 0,
            },
            "& > svg": {
                color: "inherit",
            },
        },
    },
})

export default function ErrorHint({ errMsg }: IErrorHint) {
    const classes = useStyles()
    return (
        <div className={classes.wrapper}>
            <div>
                <Warning />
            </div>
            <div>{errMsg}</div>
        </div>
    )
}
